import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'
import {createGtm} from '@gtm-support/vue-gtm'
import { BootstrapVue3 } from 'bootstrap-vue-3'
import { createI18n } from 'vue-i18n'
import './main.css'

// control where users are redirected to if not logged in
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.loggedIn) {
            next({
                name: 'Login',
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response) {
        if (error.response.status === 401) {
            store.commit('destroyToken')
            store.dispatch('destroyToken')
            router.replace({
                path: '/login',
                query: { redirect: router.currentRoute.fullPath },
            })
        }
        if (error.response.status === 511) {
            store.commit('unVerifiedEmail')
            router.replace({
                path: '/email-verification-needed',
                query: { redirect: router.currentRoute.fullPath },
            })

        }
    }
    return Promise.reject(error)
})

const app = createApp(App)
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', process.env.VUE_APP_SENTRY_APP_URL, /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.VUE_APP_SENTRY_PERFORMANCE,
  logErrors: true,

})

app.use(store)
app.use(router)
app.use(BootstrapVue3)
app.use(createGtm({
    id: process.env.VUE_APP_GTM_ID,
    queryParams: {
        environment: process.env.NODE_ENV,
    },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2829c7e26c', // Will add `nonce` to the script tag
    enabled: process.env.NODE_ENV === 'production', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: process.env.NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
}))
app.use(createI18n({
    messages: {

    }
}))
app.mount('#app')